import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-5 py-10 font-sans leading-relaxed text-gray-800 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="text-center mb-10 pb-5 border-b-2 border-gray-300">
        <h1 className="text-slate-700 mb-2 text-4xl md:text-5xl font-bold">
          سياسة الخصوصية
        </h1>
        <h2 className="text-slate-600 mb-3 text-2xl md:text-3xl font-semibold">
          Privacy Policy
        </h2>
        <h3 className="text-blue-600 mb-3 text-xl md:text-2xl font-medium">
          طفل المستقبل - mostaqbal kids
        </h3>
        <p className="text-gray-600 italic">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </div>

      {/* Highlight Box */}
      <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400 mb-8">
        <p className="text-gray-700">
          <strong>حماية الأطفال أولويتنا - Child Safety is Our Priority</strong>
          <br />
          This privacy policy outlines how طفل المستقبل (mostaqbal kids)
          educational app collects, uses, and protects information from children
          and parents. We are committed to providing a safe learning environment
          for children.
        </p>
      </div>

      {/* Important Notice for Parents */}
      <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-400 mb-8">
        <h3 className="text-red-600 mb-2 text-lg font-semibold">
          Important Notice for Parents
        </h3>
        <p className="text-gray-700">
          This app is designed for children. We comply with COPPA (Children's
          Online Privacy Protection Act) and require parental consent for
          children under 13. Please review this policy carefully before allowing
          your child to use our app.
        </p>
      </div>

      {/* Section 1 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          1. About Our App - عن تطبيقنا
        </h2>
        <p className="mb-4 text-justify">
          طفل المستقبل (mostaqbal kids) is an educational app designed to help
          children learn through interactive content, games, and educational
          activities. Our app focuses on:
        </p>
        <ul className="my-4 pl-5 space-y-2 list-disc">
          <li>Educational games and activities</li>
          <li>Age-appropriate learning content</li>
          <li>Safe, supervised learning environment</li>
          <li>Progress tracking for parents</li>
          <li>Interactive lessons in various subjects</li>
        </ul>
      </div>

      {/* Section 2 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          2. Information We Collect - المعلومات التي نجمعها
        </h2>
        <p className="mb-4 text-justify">
          We only collect information necessary to provide educational services
          and ensure child safety:
        </p>

        <div className="bg-green-50 p-4 rounded-lg mb-4">
          <h4 className="font-semibold text-green-700 mb-2">
            From Parents/Guardians:
          </h4>
          <ul className="pl-5 space-y-1 list-disc">
            <li>Parent email address (for account management)</li>
            <li>Child's first name and age</li>
            <li>Parental consent verification</li>
            <li>Contact information for important updates</li>
          </ul>
        </div>

        <div className="bg-yellow-50 p-4 rounded-lg mb-4">
          <h4 className="font-semibold text-yellow-700 mb-2">
            From Children's App Usage:
          </h4>
          <ul className="pl-5 space-y-1 list-disc">
            <li>Learning progress and achievements</li>
            <li>Time spent on educational activities</li>
            <li>Game scores and completed lessons</li>
            <li>App usage patterns (for educational improvement)</li>
          </ul>
        </div>

        <div className="bg-red-50 p-4 rounded-lg">
          <h4 className="font-semibold text-red-700 mb-2">
            We DO NOT Collect:
          </h4>
          <ul className="pl-5 space-y-1 list-disc">
            <li>Personal photos or videos from children</li>
            <li>Location data or GPS information</li>
            <li>Contact lists or phone numbers</li>
            <li>Social media information</li>
            <li>
              Any personally identifiable information beyond what's necessary
            </li>
          </ul>
        </div>
      </div>

      {/* Section 3 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          3. Parental Consent - موافقة الوالدين
        </h2>
        <p className="mb-4 text-justify">
          In compliance with COPPA and child protection laws:
        </p>
        <ul className="my-4 pl-5 space-y-2 list-disc">
          <li>
            Parents must provide verifiable consent before children can use the
            app
          </li>
          <li>
            Parents can review, modify, or delete their child's information at
            any time
          </li>
          <li>
            Parents receive notifications about their child's progress and app
            updates
          </li>
          <li>
            We require parental approval for any new features that collect
            additional data
          </li>
        </ul>
      </div>

      {/* Section 4 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          4. How We Use Information - كيف نستخدم المعلومات
        </h2>
        <p className="mb-4 text-justify">
          We use collected information solely for educational purposes:
        </p>
        <ul className="my-4 pl-5 space-y-2 list-disc">
          <li>Personalizing educational content for each child</li>
          <li>Tracking learning progress and achievements</li>
          <li>Providing progress reports to parents</li>
          <li>Improving our educational content and features</li>
          <li>Ensuring app safety and security</li>
          <li>Complying with parental requests and legal requirements</li>
        </ul>
      </div>

      {/* Section 5 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          5. Information Sharing - مشاركة المعلومات
        </h2>
        <p className="mb-4 text-justify">
          <strong>
            We NEVER sell, trade, or share children's personal information with
            third parties for marketing purposes.
          </strong>
        </p>
        <p className="mb-4 text-justify">
          Limited sharing may occur only in these situations:
        </p>
        <ul className="my-4 pl-5 space-y-2 list-disc">
          <li>
            <strong>With Parents:</strong> All child data is accessible to
            verified parents/guardians
          </li>
          <li>
            <strong>Educational Partners:</strong> Anonymous, aggregated data
            for curriculum development (no personal info)
          </li>
          <li>
            <strong>Legal Requirements:</strong> If required by law to protect
            child safety
          </li>
          <li>
            <strong>Service Providers:</strong> Trusted partners who help
            operate the app (under strict privacy agreements)
          </li>
        </ul>
      </div>

      {/* Section 6 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          6. Data Security - أمان البيانات
        </h2>
        <p className="mb-4 text-justify">
          We implement industry-standard security measures specifically designed
          for children's data protection:
        </p>
        <ul className="my-4 pl-5 space-y-2 list-disc">
          <li>Encrypted data transmission and storage</li>
          <li>Regular security audits and updates</li>
          <li>Limited access to child data (authorized personnel only)</li>
          <li>Secure servers with backup systems</li>
          <li>No advertising or third-party tracking</li>
        </ul>
      </div>

      {/* Section 7 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          7. Parental Rights - حقوق الوالدين
        </h2>
        <p className="mb-4 text-justify">
          Parents have complete control over their child's information:
        </p>
        <ul className="my-4 pl-5 space-y-2 list-disc">
          <li>
            <strong>Access:</strong> View all information collected about your
            child
          </li>
          <li>
            <strong>Modify:</strong> Update or correct your child's information
          </li>
          <li>
            <strong>Delete:</strong> Request deletion of your child's account
            and all data
          </li>
          <li>
            <strong>Restrict:</strong> Limit data collection or app features
          </li>
          <li>
            <strong>Withdraw Consent:</strong> Revoke permission for data
            collection at any time
          </li>
          <li>
            <strong>Data Export:</strong> Request a copy of your child's
            learning progress
          </li>
        </ul>
      </div>

      {/* Section 8 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          8. Age Restrictions - قيود العمر
        </h2>
        <p className="mb-4 text-justify">
          Our app is designed for children aged 3-12 years. Different age groups
          have different features and privacy protections:
        </p>
        <ul className="my-4 pl-5 space-y-2 list-disc">
          <li>
            <strong>Ages 3-5:</strong> Maximum parental supervision, minimal
            data collection
          </li>
          <li>
            <strong>Ages 6-9:</strong> Guided learning with progress tracking
          </li>
          <li>
            <strong>Ages 10-12:</strong> More interactive features with
            continued parental oversight
          </li>
          <li>
            <strong>Under 13:</strong> Full COPPA compliance and parental
            consent required
          </li>
        </ul>
      </div>

      {/* Section 9 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          9. Data Retention - الاحتفاظ بالبيانات
        </h2>
        <p className="text-justify">
          We retain child information only as long as necessary for educational
          purposes or as required by law. When a parent requests account
          deletion or when a child reaches 13 years of age, we provide options
          to delete or transfer data according to family preferences.
        </p>
      </div>

      {/* Section 10 */}
      <div className="mb-8">
        <h2 className="text-slate-600 border-l-4 border-blue-500 pl-4 mb-4 text-xl md:text-2xl font-semibold">
          10. Changes to This Policy - تغييرات السياسة
        </h2>
        <p className="text-justify">
          We will notify parents via email of any significant changes to this
          privacy policy. Continued use of the app after notification
          constitutes acceptance of the updated policy. Parents always have the
          right to withdraw consent if they disagree with changes.
        </p>
      </div>

      {/* Contact Section */}
      <div className="mb-8">
        <div className="bg-gray-100 p-5 rounded-lg border-l-4 border-green-500">
          <h3 className="text-green-600 mb-3 text-lg font-semibold">
            Contact Us - اتصل بنا
          </h3>
          <p className="mb-3">
            If you have any questions about this Privacy Policy or your child's
            data, please contact us:
          </p>
          <ul className="space-y-2 list-none">
            <li className="flex items-center">
              <span className="font-medium mr-2">Email:</span>
              <a
                href="mailto:privacy@mostaqbalkids.com"
                className="text-blue-600 hover:text-blue-800 transition-colors"
              >
                privacy@mostaqbalkids.com
              </a>
            </li>
            <li className="flex items-center">
              <span className="font-medium mr-2">Parent Support:</span>
              <a
                href="mailto:parents@mostaqbalkids.com"
                className="text-blue-600 hover:text-blue-800 transition-colors"
              >
                parents@mostaqbalkids.com
              </a>
            </li>
            <li>
              <span className="font-medium mr-2">Phone:</span>
              <a
                href="tel:+201211185562"
                className="text-blue-600 hover:text-blue-800 transition-colors"
              >
                (+20) 1211185562
              </a>
            </li>
          </ul>

          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-700">
              <strong>For urgent child safety concerns:</strong> Contact us
              immediately at
              <a
                href="mailto:safety@mostaqbalkids.com"
                className="ml-1 underline"
              >
                safety@mostaqbalkids.com
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="fixed bottom-5 right-5 bg-blue-500 text-white border-none rounded-full w-12 h-12 cursor-pointer text-lg shadow-lg hover:bg-blue-600 transition-colors duration-300 flex items-center justify-center"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        title="Back to top"
      >
        ↑
      </button>
    </div>
  );
};

export default PrivacyPolicy;
